import { FEATURE_REQUIRED_PLAN } from '@/models/User'

const PLAN_ORDER = { starter: 0, growth: 1, pro: 2, vip: 3 }

/**
 * VIP Page (site content: custom fields, gallery, unique QR): **VIP plan** or **`vip`** user flag only — not Pro-only subscribers.
 */
export function hasVipSitePageAccess(user) {
  if (!user) return false
  if (user.vip === true) return true
  return String(user.planSlug ?? user._planSlug ?? 'starter').toLowerCase() === 'vip'
}

/**
 * Whether the user may use a plan-gated feature (same rules as v-require-paid).
 * VIP flag grants **owner_orders** even when subscription plan is below Pro.
 */
export function hasPaidFeatureAccess(user, featureKey) {
  if (!user || !featureKey) return false
  const key = String(featureKey).toLowerCase()
  if (key === 'owner_orders' && user.vip === true) return true
  if (typeof user.hasFeature === 'function' && user.hasFeature(featureKey) === true) return true
  const required = FEATURE_REQUIRED_PLAN[key]
  if (!required) return false
  const planSlug = String(user.planSlug ?? user._planSlug ?? 'starter').toLowerCase()
  return (PLAN_ORDER[planSlug] ?? 0) >= (PLAN_ORDER[required] ?? 0)
}
